<template>
  <!-- Inizio repeater repeater-->
  <div>
    <div class="RepeaterTabellaDettaglio">
      <div class="TabellaDettaglio">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <td class="TDRep">
                <div class="TRIndex">
                  <div>Reparto</div>
                  <div>{{ this.attivita.Reparto }}</div>
                </div>
              </td>
              <td class="TDCom">
                <div class="TRIndex">
                  <div>Comparto</div>
                  <div>{{ this.attivita.Comparto }}</div>
                </div>
              </td>
              <td class="TDEnt">
                <div class="TRIndex">
                  <div>Entità</div>
                  <div>{{ this.attivita.DescrizioneEntita }}</div>
                </div>
              </td>
              <td class="TDAtt">
                <div class="TRIndex">
                  <div>Attività</div>
                  <div>{{ this.attivita.DescrizioneAttivita }}</div>
                </div>
              </td>
              <td class="TDNot">
                <div class="TRIndex">
                  <div>Note</div>
                  <div>
                    <form class="Form TableForm">
                      <div class="FormRow">
                        <div class="FormBox83">
                          <input type="text" id="" name="" placeholder="Aggiungi nota" v-model="this.attivita.NoteIntervento" />
                        </div>
                        <div class="FormBox16">
                          <div class="TwinButtons Min">
                            <div class="Button ExtraSmall">
                              <input type="button" id="" name="" value="Salva" @click="this.updateAttivita(0, 0, 1)" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="CheckTabellaDettaglio">
        <form class="Form">
          <div class="FormRow">
            <div class="FormBox50">
              <div class="FormCheckBox">
                <div class="CheckField">
                  <input type="checkbox" name="" id = "chekPositivo" ref="CheckPositivo" :checked="this.checkedVirtualPos" @click="this.updateAttivita(1, 0, 0)" /><span class="Checkmark" :class="{Checkmark_green: this.checkedVirtualPos}"></span>
                </div>
                <div class="CheckLabel check_label_new">Positivo</div>
              </div>
            </div>
            <div class="FormBox50">
              <div class="FormCheckBox">
                <div class="CheckField">
                  <input type="checkbox" name="" ref="CheckNegativo" :checked="this.checkedVirtualNeg" @click="this.updateAttivita(0, 1, 0)" /><span class="Checkmark" :class="{Checkmark_red: this.checkedVirtualNeg}"></span>
                </div>
                <div class="CheckLabel">Negativo</div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="ToggleButton">
        <div class="Operazioni Button Iconed Stroked Toggled ExtraSmall" @click="this.openTabs(index, this.attivita.SysChiaveglobale, $event)" :id="'operazioni' + this.index">
          <span>Operazioni/Ricambi</span>
        </div>
      </div>
    </div>
    <div class="TabHolder TabOperazioneRicambi" style="display:none"  :id="'tabsPanel' + index">
      <div class="TabButtonBox">
        <div class="TabButton SelectedItem" :id="'lnkOperazioni' + index" @click="this.openTabOperazioni(index)">Operazioni</div>
        <div class="TabButton" :id="'lnkRicambi' + index" @click="this.openTabRicambi(index)">Ricambi</div>
      </div>
      <div class="TabContentBox">
        <div class="TabContent"  :id="'tabOperazioni' + index">

          <keep-alive>
          <component
          :is="gridOperazioni"
          :chiaveAttivita="this.attivita.SysChiaveglobale"
          :attivita="this.attivita"
          >
          </component>
          </keep-alive>
        </div>
        <div class="TabContent" style="display:none;" :id="'tabRicambi' + index">
          <keep-alive>
          <component
            :is="gridRicambi"
            :chiaveAttivita="this.attivita.SysChiaveglobale"
            :attivita="this.attivita"
          ></component>
          </keep-alive>

        </div>
      </div>
    </div>
    <!-- Fine repeater repeater-->
  </div>
</template>
<script>

import GrigliaOperazioni from "@/components/GrigliaOperazioni.vue";
import GrigliaRicambi from "@/components/GrigliaRicambi.vue";
import {apiMixin} from "/mixin.js";
import EmptyComponent from "@/components/EmptyComponent.vue";

export default {
    name: "PannDettInterventiInCorsoRiga",
    props:{       
        chiaveIntervento: String,
        attivita: Object,
        index: Number
    },
    components:{
      GrigliaOperazioni,
      GrigliaRicambi,            
      EmptyComponent
    },
    data(){
      return {       
        listaRicambi: [],
        attivitaEseguita: false,
        noteInterventoAttivita: "",
        showGridOperazioni: false,
        showGridRicambi: false,
        checkedVirtualPos: false,
        checkedVirtualNeg: false
      }
    },
    computed:{
      gridOperazioni(){  
        return this.showGridOperazioni ? "GrigliaOperazioni" : "EmptyComponent";      
      },
      gridRicambi(){        
        return this.showGridRicambi ? "GrigliaRicambi" : "EmptyComponent";               
      }
    },
    mixins:[apiMixin],
    methods:{    
      openTabs: function(index, chiaveAttivita, e){

        var el = e.srcElement.parentElement;

        if(!($("#tabsPanel"+index).is(":visible"))){

          this.showGridOperazioni = true;
        }
        else{
          this.showGridOperazioni = false;
        }
        $("#tabsPanel"+index).slideToggle('fast');      
        $(el).toggleClass('Open').toggleClass('Close');
        $(el).parent().parent().toggleClass('PannelloOpen');

      },
      openTabOperazioni: function(index){
        this.showGridOperazioni = true;
        this.showGridRicambi = false;
        $("#lnkOperazioni" + index).addClass("SelectedItem");
        $("#lnkRicambi" + index).removeClass("SelectedItem");
        $("#tabRicambi" + index).fadeOut(0);
        $("#tabOperazioni" + index).fadeIn('fast'); 
      },
      openTabRicambi: function(index){

        this.showGridOperazioni = false;
        this.showGridRicambi = true;

        $("#lnkOperazioni" + index).removeClass("SelectedItem");
        $("#lnkRicambi" + index).addClass("SelectedItem");

        $("#tabRicambi" + index).fadeIn('fast');
        $("#tabOperazioni" + index).fadeOut(0);
      },      
      updateAttivita: function(positivo, negativo, mettiNote){        

        let dataUpdate = {
          SYS_CHIAVEGLOBALE: this.attivita.SysChiaveglobale
        };

        if(positivo){
          if( this.$refs.CheckPositivo.checked){
            dataUpdate.Eseguito = true;
            dataUpdate.CodiceEsito = "1POSITIVO"; 
            this.$refs.CheckNegativo.checked = false;  
          }else{   
            dataUpdate.Eseguito = false;
            dataUpdate.CodiceEsito = null; 
            this.$refs.CheckNegativo.checked = false;   
            this.$refs.CheckPositivo.checked = false;  
            this.checkedVirtualNeg = 0;
            this.checkedVirtualPos = 0;      
          }
        }

        if(negativo){
          if(this.$refs.CheckNegativo.checked){
            dataUpdate.Eseguito = true;
            dataUpdate.CodiceEsito = "1NEGATIVO"; 
            this.$refs.CheckPositivo.checked = false;
          }else{
            dataUpdate.Eseguito = false;
            dataUpdate.CodiceEsito = null; 
            this.$refs.CheckPositivo.checked = false;
            this.$refs.CheckNegativo.checked = false;
            this.checkedVirtualNeg = 0;
            this.checkedVirtualPos = 0;
          }
        }

        if(mettiNote){
          dataUpdate.NoteIntervento = this.attivita.NoteIntervento;
        }

        this.doApiCall("post", "interventi/UpdateAttivitaWeb", this.$store.getters.getUtente.Token, null, dataUpdate).then(

          (data) => {  
              if(data && data.StatusCode === 200){
                  this.$toast.success("Attività aggiornata con successo!", {position:"top-right"});                                
                  let index = this.$parent.$data.listaAttivita.findIndex(item => {return item.SysChiaveglobale === data.Data.SysChiaveglobale});
                  if(index >= 0) this.$parent.$data.listaAttivita[index] = data.Data;
                  this.$parent.$forceUpdate();
              }
              else{
                this.$toast.error("Attenzione! Si sono verificati errori durante l'aggiornamento dell'attività!", {position:"top-right"});
              }
          }
        );
      }      
    },
    updated: function(){
      $('.CustomSelect').select2({
        theme: "classic"
      });  
      
      $('.CustomSelect').on('select2:select', function (e) {        
        var codiceEsito = e.params.data.id;        
        $("#esitoSelected").val(codiceEsito);
      });
    },
      mounted : function(){
        if(this.attivita.CodiceEsito === '1NEGATIVO'){
          this.checkedVirtualNeg = 1;
          this.checkedVirtualPos = 0;
        }else{
          if(this.attivita.CodiceEsito === '1POSITIVO'){
            this.checkedVirtualPos = 1;
            this.checkedVirtualNeg = 0;
          }
        }
      },
      watch: {
        attivita: function(newValue){
          if(newValue.CodiceEsito === '1NEGATIVO'){
            this.checkedVirtualNeg = 1;
            this.checkedVirtualPos = 0;
          }else{
            if(newValue.CodiceEsito === '1POSITIVO'){
              this.checkedVirtualPos = 1;
              this.checkedVirtualNeg = 0;
            }
          }
        }
      }
}
</script>

<style>
.Checkmark_green{
  background-color: #6ab20c;
}
.Checkmark_red{
  background-color: #f91e33;
}

</style>